import React, { useState, useEffect } from 'react';
import { ArrowRight, Play, Star } from 'lucide-react';
import { metrics } from '../data/content';
import * as Icons from 'lucide-react';

const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="pt-24 pb-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center">
          <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="inline-flex items-center bg-gradient-to-r from-blue-600/20 to-purple-600/20 border border-blue-500/20 rounded-full px-6 py-2 mb-6">
              <Star className="h-4 w-4 text-yellow-400 mr-2" />
              <span className="text-blue-200 text-sm font-medium">World's First AI Corporate Meetings Platform</span>
            </div>
            
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
              Your Software
              <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent block">
                Evolves While You Sleep
              </span>
            </h1>
            
            <p className="text-xl text-slate-300 mb-8 max-w-3xl mx-auto leading-relaxed">
              HiveCluster orchestrates specialized AI agents in evolutionary sprints to autonomously improve your projects 24/7. 
              Six AI executives hold real meetings, make decisions, and evolve your software continuously.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <button className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white px-8 py-4 rounded-xl text-lg font-semibold shadow-xl transition-all duration-200 transform hover:scale-105">
                <Play className="h-5 w-5 mr-2 inline" />
                Launch Platform Now
              </button>
              <button className="border border-slate-600 hover:border-slate-500 text-white px-8 py-4 rounded-xl text-lg font-semibold transition-all duration-200 hover:bg-slate-800">
                Watch Executive Meeting
                <ArrowRight className="h-5 w-5 ml-2 inline" />
              </button>
            </div>

            {/* Metrics */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
              {metrics.map((metric, index) => {
                const IconComponent = Icons[metric.icon];
                return (
                  <div key={index} className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 text-center hover:bg-slate-800/70 transition-all duration-200">
                    <div className="flex justify-center mb-2 text-blue-400">
                      <IconComponent className="h-5 w-5" />
                    </div>
                    <div className="text-2xl font-bold text-white mb-1">{metric.value}</div>
                    <div className="text-sm text-slate-400">{metric.label}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
